import { useState } from 'react';
import useScript from 'react-script-hook';

const pathToJS = 'js/edelweissConnect.js';

const cdnUrl = process.env.REACT_APP_EDELWEISS_CONNECT_CDN_URL;

const bookfestUrl = process.env.REACT_APP_BOOKFEST_URL;

const showConnect = () =>
	process.env.REACT_APP_SHOW_EDELWEISS_CONNECT === 'true' &&
	typeof window.edelweissConnect === 'function';

const initConnect = () => {
	if (!showConnect()) return;
	return window.edelweissConnect({
		cdnUrl,
		app: `${bookfestUrl}/sessions`,
		texts: {
			open: 'Connect',
			opening: 'Loading...',
			close: 'Close',
		},
	});
};

const deinitConnect = eConnect => {
	if (!showConnect()) return;
	eConnect.deinit();
	const buttons = document.getElementsByClassName('visibility-toggle-anchor');
	buttons.forEach(btn => btn.remove && btn.remove());
};

export default function useEdelweissConnect(isMobile) {
	const [eConnect, setConnect] = useState(null);

	const initConnectOnLoad = () => {
		const eConnect = initConnect();
		setConnect(eConnect);
	};

	const [loading, error] = useScript({
		src: `${cdnUrl}/${pathToJS}`,
		onload: () => {
			if (!isMobile()) {
				initConnectOnLoad();
			}
		},
	});

	return {
		error,
		loading,
		init: initConnectOnLoad,
		isActive: eConnect !== null,
		deinit: () => {
			deinitConnect(eConnect);
			setConnect(null);
		},
	};
}
